<template>
  <div class="organization-billing-type-table-cell" :style="style">
    <span v-if="value === 'BillMeLater'">Billed</span>
    <span v-if="value === 'POT'">Point of Transaction</span>
    <span v-if="value === 'StudentPays'">Student Pays</span>
    <span v-if="value === 'SiteLicense'">Site License ({{ licensingMethod }})</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@vue';

import type { Organization } from '@models';

/**
 * `TableCellOrganizationBillingType` component properties.
 */
export interface Props {
  /** ... */
  item: Organization;
}

const props = defineProps<Props>();

const value = computed(() => props.item.billingType);

const licensingMethod = computed(() => props.item.licensingMethod);

const style = computed(() => {
  if (value.value === 'SiteLicense') {
    return {
      color: '#372920',
      backgroundColor: '#ecb38e',
    };
  }

  if (value.value === 'BillMeLater') {
    return {
      color: '#202c37',
      backgroundColor: '#85b7e4',
    };
  }

  if (value.value === 'POT') {
    return {
      color: '#372a36',
      backgroundColor: '#ecb8e8',
    };
  }

  if (value.value === 'StudentPays') {
    return {
      color: '#32372a',
      backgroundColor: '#dbefbc',
    };
  }

  return {
    color: '#272727',
    backgroundColor: '#dcdcdc',
  };
});
</script>

<script lang="ts">
declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellOrganizationBillingType: ComponentWithProps<Props>;
  }
}

export default { name: 'TableCellOrganizationBillingType' };
</script>

<style lang="scss" scoped>
.organization-billing-type-table-cell {
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 10px;
  font-size: 12px;
}
</style>
